import mainLogo from '../../images/ItavemaToyota/logo_itavema_toyota_interjapan.png';
import squareLogo from '../../images/ItavemaToyota/logo_itavema_toyota_interjapan_square_small.png';
import mainLogoWhite from '../../images/ItavemaToyota/logo_itavema_toyota_interjapan_branco.png';
import banner01 from '../../images/ItavemaToyota/concessionaria_faixa_Itavema_Toyota_2.jpg';
import banner02 from '../../images/ItavemaToyota/concessionaria_faixa_Itavema_Toyota_3.jpg';
import banner03 from '../../images/ItavemaToyota/concessionaria_faixa_Itavema_Toyota_4.jpg';
import car123 from '../../images/ItavemaToyota/123_cross.jpg';
import box123 from '../../images/ItavemaToyota/123_itvaToyota.jpg';
import { SliderProducts } from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Itavema Toyota',
    defaultStoreLink: 'pecastoyota.itavema.com.br',
    defaultContactEmail: 'atendimentotoyota@itavema.com.br',
    whatsappNumber: '11 3646 4945',
    CNPJ: '07.512.967/0027-30',
    CNPJname: 'ITVA COMERCIO DE VEICULOS LTDA',
    CNPJaddress: 'R. Clélia, 440 - anexo parte III, São Paulo - SP, CEP: 05042000',
    launchDate: '18/02/2025',

    multiContact: {},

    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        "toyota",
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "TOYOTA BOTAFOGO",
        "TOYOTA GASTÃO VIDIGAL",
    ],

    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
        },
        // {
        //     name: 'Luzes',
        //     img: 'tabLuzes',
        //     products: SliderProducts.Luzes
        // },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // },
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: mainLogoWhite,

    banner01: banner01,
    banner02: banner02,
    bannerBrands: '',
    aboutUsBg: banner03,


    car123: car123,
    box123: box123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerHighlight: 'Compre peças <mark>novas e originais</mark>, compatíveis com seu veículo. Peças <mark>genuínas</mark> direto das concessionárias <mark>Itavema Toyota</mark>.',

    aboutUs: {
        title: 'Itavema Toyota',
        content: [
            'Mais de 50 anos de história e credibilidade. Com unidades no estado de São Paulo e do Rio de Janeiro,  o Grupo Itavema é sinônimo de qualidade e confiança.',
            'O Grupo Itavema, que começou suas operações no final da década de 60 na cidade de São Paulo representa hoje, importantes montadoras do cenário nacional: Renault, Toyota, Volvo, Toyota, Hyundai, BYD, KTM e Dafra.',
            'Prezando pela excelência no atendimento aos nossos clientes, as lojas do Grupo Itavema oferecem ao público opções em veículos 0km, seminovos e na prestação dos serviços pós-venda, através das revisões periódicas, fornecimento de peças e reparos.'
        ],
        link: 'https://itavema.com.br/toyota-inter-japan-rj/empresa/quem_somos',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/toyotainterjapansp/',
        Facebook: 'https://www.facebook.com/interjapantoyota',
        LinkedIn: 'https://www.linkedin.com/company/grupo-itavema/',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [
        'Toyota GST - AV. DR. GASTÃO VIDIGAL, 1457 - Vila Leopoldina - 05314-000 - 05.027.327/0003-32',
        'Toyota SJM - RUA SENADOR NEREU RAMOS, 852 - Jardim Meriti - 25555-440 - 05.027.327/0004-13',
        'Toyota BF - RUA GENERAL SEVERIANO, 62 - Botafogo - 22290-040 - 05.027.327/0009-28',
    ],
}